import { firebase, db, auth } from '@/firebase.js';
import _ from 'lodash';

const debug = false;
const name = 'store/modules/auth.js';

import store from '@/store'
auth.onAuthStateChanged((user) => {
  if (debug) {
    if (user) {
      // User is signed in.
      if (debug) console.log(name,'auth.onAuthStateChanged User is signed in.');
    } else {
      // User is signed out.
      if (debug) console.log(name,'auth.onAuthStateChanged User is signed out.');
    }
  }
  if (debug && user) console.log(name,'auth.onAuthStateChanged user:', user);
  if (debug) console.log(name,'auth.onAuthStateChanged state.displayName:', state.displayName, (state.displayName?'[y]':'[n]'));
  if (debug && user) console.log(name,'auth.onAuthStateChanged user.displayName:', user.displayName, (!user.displayName?'[y]':'[n]'));
  // Set user in store
  store.dispatch('auth/updateUserFromAuth', user);
  // if (user && !user.displayName && state.displayName) {
  //   if (debug) console.log(name,'auth.onAuthStateChanged ...user.displayName:', user.displayName, 'state.displayName:', state.displayName, '...aggiorno lo user');
  //   store.dispatch('auth/updateUser', {
  //     displayName: state.displayName
  //   });
  // }
  // else {
  //   if (debug) console.log(name,'auth.onAuthStateChanged ...setUser');
  //   store.dispatch('auth/setUser', user);
  // }
})

const state = {
  user: undefined, // current logged user
  isUpdatingUser: false, // used for login, logout and user changes
  displayName: null // current logged displayName
}

const getters = {
  getUser (state) {
    return state.user;
  },

  getUserId (state) {
    return state.user.uid;
  }
}

const mutations = {
  /**
   * @protected setUser mutation
   * @param {*} user data
   */
  setUser (state, user) {
    if (debug) console.log(name,'mutation setUser() user:',user)
    // let newUser = null
    // if (user) newUser = getUserObjectFromUserAuth(user)
    if (!_.isEqual(state.user, user)) {
      if (debug) console.log(name,'mutation setUser() user updated')
      state.user = user;
      state.displayName = (user ? user.displayName : null);
    }
  },

  /**
   * setUserUpdating mutation
   * @param value Boolean
   */
  setUserUpdating (state, value) {
    if (debug) console.log(name,'mutation setUserUpdating() value:',value);
    state.isUpdatingUser = value;
  },

  /**
   * setUserUpdating mutation
   * @param value Boolean
   */
  setDisplayName (state, value) {
    if (debug) console.log(name,'mutation setDisplayName() value:',value);
    state.displayName = value;
  }

}

function getUserObjectFromUserAuth (user) {
  if (debug) console.log(name,'getUserObjectFromUserAuth() user:',user)
  let userData = {
    displayName: user.displayName,
    email: user.email,
    emailVerified: user.emailVerified,
    isAnonymous: user.isAnonymous,
    metadata: user.metadata,
    // o: user.o,
    phoneNumber: user.phoneNumber,
    photoURL: user.photoURL,
    providerData: user.providerData,
    // u: user.u,
    uid: user.uid,
  }
  // if (user.nickname) userData.nickname = user.nickname
  // if (user.gender) userData.gender = user.gender
  // if (user.yearOfBirth) userData.yearOfBirth = user.yearOfBirth
  // if (user.education) userData.education = user.education
  // if (user.position) userData.position = user.position
  // if (user.stripeId) userData.stripeId = user.stripeId
  // if (user.stripePaymentMethods) userData.stripePaymentMethods = user.stripePaymentMethods
  return JSON.parse(JSON.stringify(userData));
}

function getProviderOrCredential (providerName, providerData) {
  let provider = null
  let credential = null
  switch (providerName) {
    case 'google.com':
      provider = new firebase.auth.GoogleAuthProvider()
      break
    case 'facebook.com':
      provider = new firebase.auth.FacebookAuthProvider()
      break;
    case 'twitter.com':
      provider = new firebase.auth.TwitterAuthProvider()
      break
    case 'password':
      credential = new firebase.auth.EmailAuthProvider.credential(providerData.email, providerData.password);
      break
  }
  return [provider, credential]
}

const actions = {

  /**
   * Update store user after login or logout
   * @param {*} param0 
   * @param {*} authUser 
   */
  async updateUserFromAuth ({ commit }, authUser) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name, 'action updateUserFromAuth() authUser:', authUser);
      if (!authUser) {
        if (debug) console.log(name, 'action updateUserFromAuth() logout. set user null');
        commit('setUser', null);
        return resolve();
      }
      commit('setUserUpdating', true);
      // get user from DB
      let docRef = db.collection('users').doc(authUser.uid);
      docRef.get().then((doc) => {
        const dbUser = doc.data();
        if (debug) console.log(name, 'action updateUserFromAuth() dbUser:', dbUser);
        // merge authUser to DB data
        const user = Object.assign((dbUser ? dbUser : {}), getUserObjectFromUserAuth(authUser));
        if (debug) console.log(name, 'action updateUserFromAuth() new user:', user);
        commit('setUser', user)
        if (!_.isEqual(user, dbUser)) {
          // update user in DB
          if (debug) console.log(name, 'action updateUserFromAuth() user is different from DB. update DB');
          docRef.set(user, { merge: true })
          .then((data) => {
            if (debug) console.log(name, 'action updateUserFromAuth() user updated in DB. data:', data);
          })
        }
        commit('setUserUpdating', false);
        return resolve(user);
      })
      .catch((error) => {
        if (debug) console.log(name, 'action updateUserFromAuth() error:', error);
        commit('setUserUpdating', false);
        return reject(error);
      })
    })
  },

  /**
   * @public setUser action
   * @param {*} user 
   * @returns Promise
   */
  setUser ({ state, commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name,'action setUser() user:',user)
      let userData = null
      if (user) userData = getUserObjectFromUserAuth(user)
      if (debug) console.log(name,'action setUser() userData:',userData)
      let stateUserData = state.user
      // if (state.user) getUserObjectFromUserAuth(state.user)
      if (state.user) stateUserData = getUserObjectFromUserAuth(state.user)
      if (debug) console.log(name,'action setUser() stateUserData:',stateUserData)
      if (_.isEqual(userData, stateUserData)) {
        if (debug) console.log(name,'action setUser() userData ALREADY SET')
        resolve()
        return
      }
      dispatch('users/setUser', userData, {root:true})
      .then(() => {
        if (debug) console.log(name,'action setUser() userData set')
        if (!userData || !userData.uid) {
          commit('setUser', null)
          resolve()
        }
        else {
          dispatch('users/getUser', userData.uid, {root:true})
          .then((userData) => {
            commit('setUser', userData)
            resolve()
          })
        }
      })
      .catch((error) => {
        if (debug) console.log(name,'action setUser() error:',error)
        reject(error)
      })
    })
  },

  // updateUserFromUsersModule ({ state, commit, dispatch }, user) {
  // }

  /**
   * createUserWithEmailAndPassword action
   * @param userData {name, email, password}
   * @returns Promise
   */
  createUserWithEmailAndPassword ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name,'action createUserWithEmailAndPassword() name:',userData.name,'email:',userData.email,'password:',userData.password)
      commit('setDisplayName', userData.name)
      commit('setUserUpdating', true)
      // To create user and login without email confirmation:
      auth.createUserWithEmailAndPassword(userData.email, userData.password)
      .then((response) => {
        if (this.debug) console.log(name,'action createUserWithEmailAndPassword() created response:',response,'user:',response.user,'email:',this.email,'password:',this.password,'name:',this.name);
      //   if (response.user.updateProfile) {
      //     if (this.name && this.name !== '') {
      //       // response.user.updateProfile({ displayName: this.name })
      //       auth.currentUser.updateProfile({ displayName: userData.name })
      //       .then(() => {
      //         // auth.currentUser.displayName = this.name;
      //         if (this.debug) console.log(name,'action createUserWithEmailAndPassword() name updated.');
      //         // if (this.debug) console.log(name,'action createUserWithEmailAndPassword() ...auth.currentUser:',auth.currentUser);
      //         // if (this.debug) console.log(name,'action createUserWithEmailAndPassword() ...response.user:',response.user);
      //         // return dispatch('setUser', auth.currentUser)
      //         // .then(() => {
      //           commit('setUserUpdating', false)
      //           resolve()
      //         // })
      //       })
      //       .catch((error) => {
      //         if (this.debug) console.log(name,'action createUserWithEmailAndPassword() updating name error:',error);
      //         commit('setUserUpdating', false)
      //         reject('updating name error:',error)
      //       });
      //     }
      //   }
      //   else {
      //     if (this.debug) console.warn(name,'action createUserWithEmailAndPassword() user.updateProfile() doesn\'t exists.');
      //     commit('setUserUpdating', false)
      //     reject('user.updateProfile() doesn\'t exists')
      //   }
      })
      .catch((error) => {
        // if (this.debug)
        console.log(name,'action createUserWithEmailAndPassword() error:',error);
        commit('setUserUpdating', false)
        reject(error)
      })
      .finally(() => {
        if (this.debug) console.log(name,'action createUserWithEmailAndPassword() finally');
        commit('setUserUpdating', false)
        resolve()
      });

    })
  },

  /**
   * loginUserWithProvider action
   * @param providerName the url of provider: google.com, facebook.com, twitter.com or password
   * @param providerData optional. data to set in password provider
   * @returns Promise
   */
  loginUserWithProvider ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let providerName, providerData
      if (typeof payload === 'string') {
        providerName = payload
      }
      else {
        providerName = payload.providerName
        providerData = payload.providerData
      }
      if (debug) console.log(name,'action loginUserWithProvider() providerName:',providerName,'providerData:',providerData)

      let [provider, credential] = getProviderOrCredential(providerName, providerData)
      if (!provider && !credential) {
        if (debug) console.log(name,'action loginUserWithProvider() Provider URL not correct')
        reject('Provider URL not correct')
        return
      }
      commit('setUserUpdating', true)
      Promise.resolve()
      .then(() => {
        if (provider) return auth.signInWithPopup(provider)
        else return auth.signInWithEmailAndPassword(providerData.email, providerData.password)
      })
      .then((response) => {
        if (debug) console.log(name,'action loginUserWithProvider() signed in to provider',providerName)
        if (debug) {
          console.log(name,'action loginUserWithProvider() response:',response);
          // This gives you a Google Access Token. You can use it to access the Google API.
          // let token = response.credential.accessToken;
          // The signed-in user info.
          // let user = response.user;
          // console.log(name,'action loginUserWithProvider() ok. token:',token,'user:',user,'response:',response);
        }
        commit('setUserUpdating', false)
        resolve()
      })
      .catch((error) => {
        if (debug) console.log(name,'action loginUserWithProvider() error:',error)
        // Handle Errors here.
        if (debug) {
          let errorCode = error.code;
          let errorMessage = error.message;
          // The email of the user's account used.
          let email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          let credential = error.credential;
          console.warn(name,'action loginUserWithProvider() errorCode:',errorCode,'errorMessage:',errorMessage,'email:',email,'credential:',credential,'error:',error);
        }
        commit('setUserUpdating', false)
        reject(error)
      });
    })
  },

  /**
   * signOutUser action
   * @returns Promise
   */
  signOutUser ({ commit }) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name,'action signOutUser()')
      commit('setUserUpdating', true)
      auth.signOut()
      .then((response) => {
        if (debug) console.log(name,'action signOutUser() response:',response)
        commit('setUserUpdating', false)
        resolve()
      })
      .catch((error) => {
        if (debug) console.log(name,'action addUserProvider() error:',error)
        commit('setUserUpdating', false)
        reject(error)
      });
    })
  },

  /**
   * resetUserPassword action
   * @param email
   * @returns Promise
   */
  resetUserPassword (context, email) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name,'action resetUserPassword() email:',email)
      auth.sendPasswordResetEmail(email)
      .then((response) => {
        if (debug) console.log(name,'action resetUserPassword() response:',response)
        resolve()
      })
      .catch((error) => {
        if (debug) console.log(name,'action resetUserPassword() error:',error)
        reject(error)
      });
    })
  },

  /**
   * addUserProvider action
   * @param providerName the url of provider: google.com, facebook.com, twitter.com or password
   * @param providerData optional. data to set in password provider
   * @returns Promise
   */
  addUserProvider ({ commit, dispatch }, providerName, providerData) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name,'action addUserProvider() providerName:',providerName)

      let [provider, credential] = getProviderOrCredential(providerName, providerData)
      if (!provider && !credential) {
        if (debug) console.log(name,'action addUserProvider() Provider URL not correct')
        reject('Provider URL not correct')
        return
      }
      commit('setUserUpdating', true)
      Promise.resolve()
      .then(() => {
        if (provider) return auth.currentUser.linkWithPopup(provider)
        else return auth.currentUser.linkAndRetrieveDataWithCredential(credential)
      })
      .then((response) => {
        if (debug) console.log(name,'action addUserProvider() Provider',providerName,'added')
        if (debug) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          let token = response.credential.accessToken
          console.log(name,'action addUserProvider() ok. token:',token,' response:',response)
        }
        // The signed-in user info.
        if (debug) console.log(name,'action addUserProvider() response.user:',response.user)
        return dispatch('setUser', response.user)
        .then(() => {
          commit('setUserUpdating', false)
          resolve()
        })
      })
      .catch((error) => {
        if (debug) console.log(name,'action addUserProvider() error:',error)
        // Handle Errors here.
        if (debug) {
          let errorCode = error.code
          let errorMessage = error.message
          // The email of the user's account used.
          let email = error.email
          // The firebase.auth.AuthCredential type that was used.
          let credential = error.credential
          console.warn(name,'action addUserProvider() errorCode:',errorCode,'errorMessage:',errorMessage,'email:',email,'credential:',credential,'error:',error)
        }
        commit('setUserUpdating', false)
        reject(error)
      })
    })
  },

  /**
   * removeUserProvider action
   * @param providerName the url of provider: google.com, facebook.com or twitter.com
   * @returns Promise
   */
  removeUserProvider ({ commit, dispatch }, providerName) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name,'action removeUserProvider() providerName:',providerName);
      if (providerName !== 'google.com' &&
          providerName !== 'facebook.com' &&
          providerName !== 'twitter.com' &&
          providerName !== 'password') {
        reject('Provider URL not correct')
        return
      }
      commit('setUserUpdating', true)
      auth.currentUser.unlink(providerName)
      .then((user) => {
        if (debug) console.log(name,'action removeUserProvider() Provider',providerName,'removed. user:',user)
        return dispatch('setUser', user)
        .then(() => {
          commit('setUserUpdating', false)
          resolve()
        })
      })
      .catch((error) => {
        if (debug) console.log(name,'action removeUserProvider() error:',error)
        // Handle Errors here.
        if (debug) {
          let errorCode = error.code
          let errorMessage = error.message
          // The email of the user's account used.
          let email = error.email
          // The firebase.auth.AuthCredential type that was used.
          let credential = error.credential
          console.warn(name,'action removeUserProvider() errorCode:',errorCode,'errorMessage:',errorMessage,'email:',email,'credential:',credential,'error:',error)
        }
        commit('setUserUpdating', false)
        reject(error.message)
      })
    })
  },

  /**
   * updateUser action
   * @param userData data to update
   * @returns Promise
   */
  updateUser ({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name,'action updateUser() userData:',userData);
      commit('setUserUpdating', true)
      auth.currentUser.updateProfile(userData)
      .then(() => {
        if (debug) console.log(name,'action updateUser() userData updated');
        let currentUser = JSON.parse(JSON.stringify(auth.currentUser));
        if (userData.trainerCredits) currentUser.trainerCredits = userData.trainerCredits
        else currentUser.trainerCredits = 0
        if (userData.nickname) currentUser.nickname = userData.nickname
        else currentUser.nickname = null
        if (userData.gender) currentUser.gender = userData.gender
        else currentUser.gender = null
        if (userData.yearOfBirth) currentUser.yearOfBirth = userData.yearOfBirth
        else currentUser.yearOfBirth = null
        if (userData.education) currentUser.education = userData.education
        else currentUser.education = null
        if (userData.position) currentUser.position = userData.position
        else currentUser.position = null
        if (debug) console.log(name,'action updateUser() ...setUser... currentUser:',currentUser);
        return dispatch('setUser', currentUser)
        .then(() => {
          commit('setUserUpdating', false)
          resolve()
        })
      })
      .catch((error) => {
        if (debug) console.log(name,'action updateUser() error:',error);
        commit('setUserUpdating', false)
        reject(error.message)
      });
    })
  }

}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}